import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import {
	useBlockProps,
	RichText,
	InnerBlocks,
	InspectorControls,
} from '@wordpress/block-editor';
const { useDispatch, useSelect } = wp.data;
const { createBlock } = wp.blocks;
import { MDCTabBar } from '@material/tab-bar';
import './editor.scss';
import {
	Button,
	PanelBody,
	TextControl,
	ToggleControl,
} from '@wordpress/components';

export default function Edit( {
	attributes: {
		tabs = [],
		templates = [],
		themeDark,
	},
	setAttributes,
	clientId,
} ) {
	const blockProps = useBlockProps();
	const [ tabCounter, setTabCounter ] = useState( 0 );
	const [ activeTabIndex, setActiveTabIndex ] = useState( 0 );
	const { replaceInnerBlocks } = useDispatch( 'core/block-editor' );
	const { innerBlocks } = useSelect( ( select ) => ( {
		innerBlocks: select( 'core/block-editor' ).getBlocks( clientId ),
	} ) );
	const handleAddTab = () => {
		setTabCounter( ( tabCounters ) => tabCounters + 1 );
		const tabId = `tab${ tabCounter }`;
		setAttributes( {
			tabs: [
				...tabs,
				{
					tabId,
					index: tabs.length,
					title: `Add Question`,
					description: '',
				},
			],
		} );

		const attr = {
			tabScreenIndex: tabs.length,
			tabId,
			index: tabs.length,
			className: 'brand-tab-screen',
		};
		const blocks = [
			...innerBlocks,
			...[ createBlock( 'create-block/tabquestion', attr ) ],
		];

		setActiveTab( tabs.length, blocks );
	};
	const setActiveTab = ( tabIndex, blocks = [ ...innerBlocks ] ) => {
		setActiveTabIndex( tabIndex );
		const tab = new MDCTabBar( document.querySelector( '.mdc-tab-bar' ) );
		tab.scrollIntoView( tabIndex );

		const innerBlocksNew = blocks.map( ( innerBlock, index ) => {
			const block = innerBlock;
			block.attributes.style = { display: 'none' };
			if ( tabIndex === index ) {
				block.attributes.style = { display: 'block' };
			}
			return block;
		} );

		replaceInnerBlocks( clientId, innerBlocksNew, false );
	};
	const handleRemoveTab = ( tab ) => {
		const newTemplates = templates
			.filter( ( item ) => item[ 1 ].index !== tab.index )
			.map( ( i ) => {
				if ( i[ 1 ].index > tab.index ) {
					i[ 1 ].index -= 1;
				}
				return i;
			} );
		const newTabs = tabs
			.filter( ( item ) => item.index !== tab.index )
			.map( ( i ) => {
				if ( i.index > tab.index ) {
					i.index -= 1;
				}
				return i;
			} );
		setAttributes( {
			tabs: newTabs,
			templates: newTemplates,
		} );
		const blocks = [ ...innerBlocks ];
		blocks.splice( tab.index, 1 );
		const previousTabIndex = tab.index === 0 ? 0 : tab.index - 1;
		setActiveTab( previousTabIndex, blocks );
	};
	const onThemeDark = ( newLinkTarget ) => {
		setAttributes( { themeDark: newLinkTarget } );
	};

	const tabBar = ( value ) => {
		return value
			.sort( ( a, b ) => a.index - b.index )
			.map( ( tab, index ) => {
				return (
					<div key={ index }>
						<InspectorControls>
							<PanelBody>
								<TextControl
									label={ __(
										'Write Question',
										'ask-faq'
									) }
									placeholder={ __(
										'Write Question',
										'ask-faq'
									) }
									value={ tab.title }
									onChange={ ( title ) => {
										const newObject = Object.assign(
											{},
											tab,
											{
												title,
											}
										);
										setAttributes( {
											tabs: [
												...tabs.filter(
													( item ) =>
														item.index !== tab.index
												),
												newObject,
											],
										} );
									} }
								/>
							</PanelBody>
						</InspectorControls>
						<div
							className="mdc-tab mdc-tab--active"
							role="tab"
							aria-selected="true"
							tabindex={ tab.index }
							onClick={ () => setActiveTab( tab.index ) }
						>
							<span className="mdc-tab__content">
								<RichText
									tagName="span"
									className="mdc-tab__text-label"
									placeholder={ `Add Question` }
									allowedFormats={ [
										'core/bold',
										'core/italic',
									] }
									onChange={ ( title ) => {
										const newObject = Object.assign(
											{},
											tab,
											{
												title,
											}
										);
										setAttributes( {
											tabs: [
												...tabs.filter(
													( item ) =>
														item.index !== tab.index
												),
												newObject,
											],
										} );
									} }
								/>
							</span>
							<span
								className={
									tab.index === activeTabIndex
										? 'mdc-tab-indicator mdc-tab-indicator--active'
										: 'mdc-tab-indicator'
								}
							>
								<span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span className="mdc-tab__ripplex"></span>
							<Button
								isSmall={ true }
								className="components-button block-editor-inserter__toggle has-icon"
								iconSize={ 24 }
								onClick={ () => handleRemoveTab( tab ) }
							>
								<svg
									width="15"
									height="15"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 384 512"
								>
									<path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
								</svg>
							</Button>
						</div>
					</div>
				);
			} );
	};

	useEffect( () => {
		new MDCTabBar( document.querySelector( '.mdc-tab-bar' ) );
		setActiveTab( 0 );
		if ( tabs.length === 0 ) {
			handleAddTab();
		}
	}, [] );

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<ToggleControl
						label={ __( 'Dark Mode', 'ask-faq' ) }
						checked={ themeDark }
						onChange={ onThemeDark }
					/>
				</PanelBody>
			</InspectorControls>
			<div
				{ ...blockProps }
				className={ themeDark ? 'tab-wrap theme-dark' : 'tab-wrap' }
			>
				<div className="tab-wrapper">
					<div className="mdc-tab-bar" role="tablist">
						<div className="mdc-tab-scroller">
							<div className="mdc-tab-scroller__scroll-area">
								<div className="mdc-tab-scroller__scroll-content">
									{ tabBar( tabs ) }
								</div>
							</div>
							<div
								className="mdc-tab"
								role="tab"
								aria-selected="true"
								onClick={ handleAddTab }
							>
								<span className="mdc-tab-indicator new-tab-add">
									<span className="mdc-tab-indicator__content"></span>
								</span>
								<span className="mdc-tab__ripple plus-btn">
									<svg
										width="15"
										height="15"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 448 512"
									>
										<path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
									</svg>
								</span>
							</div>
						</div>
					</div>
					<InnerBlocks
						allowedBlocks={ [ 'create-block/tabquestion' ] }
						templateLock="all"
					/>
				</div>
			</div>
		</>
	);
}
